import Discounts from "./Discounts";

export default Discounts;